import React, { useState } from 'react';
import { Triangle, Eye, EyeOff, ArrowRight, Github } from 'lucide-react';
interface RegisterPageProps {
  onRegister: () => void;
  onBackToLogin: () => void;
}
export function RegisterPage({
  onRegister,
  onBackToLogin
}: RegisterPageProps) {
  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    password: '',
    confirmPassword: ''
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // In a real app, validation and API call would go here
    onRegister();
  };
  return <div className="min-h-screen bg-astro-dark text-white font-sans selection:bg-astro-green selection:text-black flex flex-col" data-id="element-1607">
      {/* Navbar */}
      <nav className="sticky top-0 z-50 bg-astro-dark/80 backdrop-blur-md border-b border-astro-border h-16" data-id="element-1608">
        <div className="max-w-7xl mx-auto px-6 h-full flex items-center justify-between" data-id="element-1609">
          <div className="flex items-center gap-2 cursor-pointer" onClick={onBackToLogin} data-id="element-1610">

            <Triangle className="text-astro-green fill-astro-green" size={24} strokeWidth={2.5} data-id="element-1611" />

            <span className="text-xl font-bold text-white tracking-tight" data-id="element-1612">
              Astrolayb
            </span>
          </div>
          <button onClick={onBackToLogin} className="text-sm font-medium text-astro-text-secondary hover:text-white transition-colors" data-id="element-1613">

            Log in
          </button>
        </div>
      </nav>

      {/* Content */}
      <div className="flex-1 flex items-center justify-center p-6" data-id="element-1614">
        <div className="w-full max-w-md" data-id="element-1615">
          <div className="text-center mb-8" data-id="element-1616">
            <h1 className="text-3xl font-bold mb-2" data-id="element-1617">Create your account</h1>
            <p className="text-astro-text-secondary" data-id="element-1618">
              Start securing your cloud infrastructure in minutes.
            </p>
          </div>

          <div className="bg-astro-card border border-astro-border rounded-xl p-8 shadow-2xl" data-id="element-1619">
            <form onSubmit={handleSubmit} className="space-y-5" data-id="element-1620">
              <div data-id="element-1621">
                <label className="block text-sm font-medium text-astro-text-secondary mb-1.5" data-id="element-1622">
                  Full Name
                </label>
                <input type="text" placeholder="Jane Doe" className="w-full bg-[#0a0e14] border border-astro-border rounded-lg px-4 py-2.5 text-sm text-white placeholder:text-astro-text-secondary/50 focus:outline-none focus:border-astro-green/50 transition-colors" value={formData.fullName} onChange={e => setFormData({
                ...formData,
                fullName: e.target.value
              })} data-id="element-1623" />

              </div>

              <div data-id="element-1624">
                <label className="block text-sm font-medium text-astro-text-secondary mb-1.5" data-id="element-1625">
                  Work Email
                </label>
                <input type="email" placeholder="jane@company.com" className="w-full bg-[#0a0e14] border border-astro-border rounded-lg px-4 py-2.5 text-sm text-white placeholder:text-astro-text-secondary/50 focus:outline-none focus:border-astro-green/50 transition-colors" value={formData.email} onChange={e => setFormData({
                ...formData,
                email: e.target.value
              })} data-id="element-1626" />

              </div>

              <div data-id="element-1627">
                <label className="block text-sm font-medium text-astro-text-secondary mb-1.5" data-id="element-1628">
                  Password
                </label>
                <div className="relative" data-id="element-1629">
                  <input type={showPassword ? 'text' : 'password'} className="w-full bg-[#0a0e14] border border-astro-border rounded-lg px-4 py-2.5 text-sm text-white placeholder:text-astro-text-secondary/50 focus:outline-none focus:border-astro-green/50 transition-colors pr-10" value={formData.password} onChange={e => setFormData({
                  ...formData,
                  password: e.target.value
                })} data-id="element-1630" />

                  <button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute right-3 top-1/2 -translate-y-1/2 text-astro-text-secondary hover:text-white transition-colors" data-id="element-1631">

                    {showPassword ? <EyeOff size={16} data-id="element-1632" /> : <Eye size={16} data-id="element-1633" />}
                  </button>
                </div>
              </div>

              <div data-id="element-1634">
                <label className="block text-sm font-medium text-astro-text-secondary mb-1.5" data-id="element-1635">
                  Confirm Password
                </label>
                <input type="password" className="w-full bg-[#0a0e14] border border-astro-border rounded-lg px-4 py-2.5 text-sm text-white placeholder:text-astro-text-secondary/50 focus:outline-none focus:border-astro-green/50 transition-colors" value={formData.confirmPassword} onChange={e => setFormData({
                ...formData,
                confirmPassword: e.target.value
              })} data-id="element-1636" />

              </div>

              <button type="submit" className="w-full py-3 bg-astro-green text-black font-bold rounded-lg hover:bg-astro-green-dark transition-colors shadow-[0_0_20px_rgba(34,197,94,0.2)] flex items-center justify-center gap-2" data-id="element-1637">

                Create Account <ArrowRight size={18} data-id="element-1638" />
              </button>
            </form>

            <div className="relative my-6" data-id="element-1639">
              <div className="absolute inset-0 flex items-center" data-id="element-1640">
                <div className="w-full border-t border-astro-border" data-id="element-1641"></div>
              </div>
              <div className="relative flex justify-center text-xs uppercase" data-id="element-1642">
                <span className="bg-astro-card px-2 text-astro-text-secondary" data-id="element-1643">
                  Or continue with
                </span>
              </div>
            </div>

            <button type="button" className="w-full py-2.5 border border-astro-border text-white font-medium rounded-lg hover:bg-white/5 transition-colors flex items-center justify-center gap-2" data-id="element-1644">

              <Github size={18} data-id="element-1645" /> Sign up with GitHub
            </button>

            <p className="mt-6 text-center text-sm text-astro-text-secondary" data-id="element-1646">
              Already have an account?{' '}
              <button onClick={onBackToLogin} className="text-astro-green hover:underline font-medium" data-id="element-1647">

                Log in
              </button>
            </p>
          </div>

          <p className="mt-6 text-center text-xs text-astro-text-secondary/60 max-w-xs mx-auto" data-id="element-1648">
            By creating an account, you agree to our Terms of Service and
            Privacy Policy. We'll create your organization automatically.
          </p>
        </div>
      </div>
    </div>;
}